import React, { useState, useEffect } from "react";
import { getFirestore, collection, getDocs } from "firebase/firestore/lite";
import SVTableSales from "../components/SVTableSales";
import { Button, Spinner, Alert } from "react-bootstrap";
import SVTableDiscounts from "../components/SVTableDiscounts";
import SVCashClosingForm from "../components/SVCashClosingForm";
import {
  getCurrentCustomDate,
  getCurrentTurno,
} from "../components/Metadata/Utils";

const SVTaquillaPage = ({ usuario }) => {
  const [tickets, setTickets] = useState([]);
  const [fecha, setFecha] = useState(getCurrentCustomDate());
  const [turno, setTurno] = useState(getCurrentTurno());
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [variant, setVariant] = useState("Info");

  const actualizarDatosFila12 = async () => {
    setLoading(true);
    setMessage("");
    setVariant("Info");

    try {
      const response = await fetch(
        "https://getreportfila12-glgtkvn45q-uc.a.run.app/",
      );
      if (!response.ok) throw new Error("Error en la API");

      const data = await response.json();
      console.log("Respuesta API:", data);
      setVariant("success");
      setMessage("✅ Actuaització completada");
      const refreshTickets = await getTicketsByDate(fecha, turno);
      setTickets(refreshTickets);
    } catch (error) {
      console.error(error);
      setVariant("danger");
      setMessage("❌ Error en la cargar. Contacta amb suport informàtic");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      const data = await getTicketsByDate(fecha, turno);
      setTickets(data);
    }
    fetchData();
  }, [fecha, turno]);

  function convertToInputDate(customDate) {
    // Convierte de dd_mm_yyyy a yyyy-MM-dd (formato que usa el input date)
    let [d, m, y] = customDate.split("_");
    if (!d || !m || !y) return "";
    if (d < 10) d = "0" + d;
    if (m < 10) m = "0" + m;
    return `${y}-${m}-${d}`;
  }

  function convertToCustomDate(inputDate) {
    // inputDate: "yyyy-MM-dd"
    if (!inputDate) return "";
    const [y, m, d] = inputDate.split("-");
    // Eliminamos ceros a la izquierda
    return `${parseInt(d)}_${parseInt(m)}_${y}`;
  }

  async function getTicketsByDate(dateKey, turno) {
    const path = `Fila12/Sales/${dateKey}/Time/${turno}`;
    const colRef = collection(getFirestore(), path);

    const snapshot = await getDocs(colRef);
    const tickets = snapshot.docs.map((doc) => doc.data());

    return tickets;
  }

  return (
    <>
      {usuario.hasTaquillaAcces && (
        <div className="container mt-4">
          <h3>Facturació</h3>

          <div className="mb-3 d-flex gap-2">
            <input
              type="date"
              className="form-control w-auto"
              value={convertToInputDate(fecha)}
              onChange={(e) => {
                const formatted = convertToCustomDate(e.target.value);
                setFecha(formatted);
              }}
            />
            <select
              className="form-select w-auto"
              value={turno}
              onChange={(e) => setTurno(e.target.value)}
            >
              <option value="morning">Mati</option>
              <option value="afternoon">Tarda</option>
            </select>
            <div className="text-right">
              <Button
                variant="primary"
                onClick={actualizarDatosFila12}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Carregant...
                  </>
                ) : (
                  "Actualitzar"
                )}
              </Button>
            </div>
          </div>
          <div>
            {message && (
              <Alert
                variant={variant}
                className=""
                onClose={() => setMessage(false)}
                dismissible
              >
                {message}
              </Alert>
            )}
          </div>
          <div className="table-responsive">
            <SVTableSales data={tickets} />
          </div>
          <div className="table-responsive">
            <SVTableDiscounts data={tickets} />
          </div>
          <SVCashClosingForm
            fecha={fecha}
            turno={turno}
            tickets={tickets}
            usuario={usuario}
          />
        </div>
      )}
    </>
  );
};

export default SVTaquillaPage;
